<template>
  <div>
    <Breadcrumb :title="'Transfer Upload'"></Breadcrumb>
    <div class="row no-gutters">
      <div class="col">
        <button
          class="btn btn-primary"
          style="float:right;"
          @click.prevent="downloadTemplate"
        >Download Template</button>
        <button
          class="btn btn-secondary"
          style="float:right;margin-right:10px;"
          @click.prevent="backtoTransfer"
        >
          <span class="k-icon k-i-undo"></span> &nbsp;Back to Transfer
        </button>
      </div>
    </div>
    <div class="row">
      <br>
    </div>
    <BaseAuditDropzone
      ref="ParentFileUploaded"
      :id="'Transferdropzone'"
      :acceptedFileTypes="SheetJSFT"
      @change="_change"
      @Remove="ClearForm"
      :File="inputfile"
      :UploadType="FileUploadType"
    ></BaseAuditDropzone>
    <br>
    <br>
    <div v-show="displayPage">
        <div class="row no-gutters">
                <div class="col">
                    <div id="customerrors" class="alert alert-danger" v-if="customerrors.length>0">
                        <p>
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li v-for="error in customerrors" :key="error">{{ error }}</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
      <div class="row no-gutters">
        <div class="col">
          <div class="form-row">
            <div class="col-md-12">
              <BaseGrid
                :mode="'editform'"
                :config="TransferUploadGridConfig"
                :data="dataTransferExcel"
                @DeleteItem="DeleteDIfromGrid"
              >
                <!-- @EditItem="EditPartner"  -->
              </BaseGrid>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <br>
      </div>
      <div class="row no-gutters" style="float: right;">
        <button
          type="button"
          id="btnSave"
          class="btn btn-primary"
          :disabled="!isValid||customerrors.length>0||dataTransferExcel.length<=0"
          @click="SaveTransfer"
        >Save</button>
      </div>
      <div class="row no-gutters" style="float: right;">
        <button
          type="button"
          id="btnSave"
          class="btn btn-secondary"
          @click="validateTransfer"
        >Validate</button>
      </div>
      <div class="row">
        <br>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import customAxios from "@/services/customAxios.js";
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import sheetJSConfig from "@/configs/sheetJS.js";
import XLSX from "xlsx";
import { isNullOrUndefined } from "util";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import BaseProgram from "@/models/BaseModelProgram.js";
import BasePartner from "@/models/BaseModelPartner.js";
import BaseTransfer from "@/models/BaseModelTransfer.js";

import { mapActions, mapState, mapGetters } from "vuex";
import { TransferUploadGridConfig } from "@/views/transfer/TransferUploadconfig.js";
import BaseModelDirectInvestmentValuation from "@/models/BaseModelDirectInvestmentValuation.js";
import BaseModelProgram from '@/models/BaseModelProgram.js';
import BaseModelPartner from '@/models/BaseModelPartner.js';
import BaseModelUnitClass from '@/models/BaseModelUnitClass.js';
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import VestingScheduleDatesMixin from "@/mixins/VestingScheduleDatesMixin.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";

export default {
  components: {
    BaseGrid,
    Breadcrumb,
    BaseAuditDropzone
  },
  mixins: [apiUtil, funcUtil,VestingScheduleDatesMixin,DocumentManagerMixin],
  data() {
    return {
      data: "",
      inputfile: {
        UploadFile: {}
      },
      //UploadFile:excelfile,
      displayPage: false,
      FileUploadType: {
        AllowMultiple: "false"
      },
      SheetJSFT: sheetJSConfig.fileType,
      TransferUploadGridConfig: TransferUploadGridConfig,
      dataTransferExcel: [],
     
      PartnerAPIData: [],
      InvestmentAPIData: [],
      customerrors: [],
      isValid: false,
      dropdowns: {
        UnitType: { model: "", dataSource: [] }, 
        VestingType: { model: "", dataSource: [] },
        UnitPool:{ model: "", dataSource: []},
      },
       bulkUploadAuditConfig: bulkUploadAuditConfig,
    };
  },
  computed: {
     $eumAuth: function(){
       return this.$root.$eumAuth;
     },
    ...mapState("postModule", ["response"]),
    ...mapGetters("getModule", ["getAllItemFilter","withFilter","getAll","getLocalInputControls"])
  },
  methods: {
    ...mapActions("postModule", ["CreateAllItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),
    _suppress(evt) {
      evt.stopPropagation();
      evt.preventDefault();
    },
    downloadTemplate() {

      let token = localStorage.getItem("eum")
      let tokenstr = `Bearer ${token}`
      let templateUrl = getUrl("TransferExcel");
      let templateFileName = getFileName("TransferExcel");
      
           customAxios({
              url: templateUrl,
              method: 'GET',
              headers: {
                'Authorization': tokenstr
              },
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });
    },

    _drop(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      const files = evt.BaseModelTransfer.files;
      if (files && files[0]) this._file(files[0]);
    },
    _change(evt) {
      const files = this.inputfile.UploadFile[0];
      if (files) this._file(files);
    },
    _export(evt) {
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(wb, "sheetjs.xlsx");
    },
    backtoTransfer: function() {
      this.$router.push("/event/transfer");
    },
    _file(file) {
      /* Boilerplate to set up FileReader */
      try {
        const self = this;
        const XLSX = require("xlsx");
        const reader = new FileReader();
        reader.onload = e => {
          /* Parse data */
          //const bstr = e.target.result;
          let binary = "";
          let bytes = new Uint8Array(e.target.result);
          let length = bytes.byteLength;

          for (let i = 0; i < length; i++) 
          {
              binary += String.fromCharCode(bytes[i]);
          }
          const bstr = binary
          const wb = XLSX.read(bstr, {
            type: "binary"
          });
          /* Get Partner  data */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws, {
            range: sheetJSConfig.template.header - 1, 
            header: 1
          });
          console.log(data);
          data.splice(0, 1);
          if (data && data.length) {
            //get partner and Program
            let response = this.getAllItemFilter({
              Partner: {
                config: BasePartner
              },
              Program: {
                config: BaseProgram
              }
            });
            if (response) {
              this.PartnerAPIData = response.Partner;
              this.ProgramAPIData = response.Program;
            }
            //if (this.HeaderRow != "") {
            this.displayPage = true;

            var TransferExcelArr = [];
            var count = 1;
            for (var i = 0; i < data.length; i++) {
              var TransferExcelObj = {};
              TransferExcelObj.TransferKey = count++;
              TransferExcelObj.ProgramProgramID = data[i][0];
      
              TransferExcelObj.SenderSenderID=data[i][2]
              TransferExcelObj.ReceiverReceiverID = data[i][4];

              if (data[i][6]) {
                TransferExcelObj.UnitClass = this._firstLetterToUpper( data[i][6].toString());
              }
              if (data[i][7]) {
                TransferExcelObj.UnitType =this._firstLetterToUpper( data[i][7]);
              }
              if (data[i][8]) {
                TransferExcelObj.VestingType =this._firstLetterToUpper( data[i][8]);
              }
              if(data[i][9])
              {
                TransferExcelObj.UnitPool =this._firstLetterToUpper(data[i][9]);
              }          
              TransferExcelObj.Unit = data[i][10];
              TransferExcelObj.TransactionDate = self._getExcelPlatformCode(data[i][11]);
              // moment(
              //   new Date(Math.round((data[i][11] - 25569) * 86400 * 1000))
              // ).format("MM/DD/YYYY");

              TransferExcelObj.BusinessEvent = "Transfer";

              TransferExcelObj.Status = "Pending";

              //Get Vesting Dates
              //let VestingScheduleResponse=this.withFilter(BaseModelVestingSchedule.list,{filter: "ProgramID eq " + TransferExcelObj.ProgramProgramID +" and UnitClass eq "+"'"+TransferExcelObj.UnitClass +"'"})
              
              let VestingScheduleResponse = this.getAll(BaseModelVestingSchedule.list)
                .filter(vestingschedule=>vestingschedule.ProgramID == TransferExcelObj.ProgramProgramID && vestingschedule.UnitClass == TransferExcelObj.UnitClass);
                            
                
              this._getVestingDates(TransferExcelObj,VestingScheduleResponse);
              
              this._updateHireDate(TransferExcelObj);
              
              TransferExcelArr.push(TransferExcelObj);
            }
            this.dataTransferExcel = TransferExcelArr;
            this.getPartnerDetails();
            this.getProgramDetails();

            var grid = $("#TransferUploadGrid").data("kendoGrid");

            grid.dataSource.data(this.dataTransferExcel);
            console.log(JSON.stringify(this.dataTransferExcel));
          }
          else{
            this._AlertPopup("Template is Empty","error").then((result) => {
            })
          }

          /* Update state */
          //this.data = data;
          //console.log(JSON.stringify(data));
        };
        reader.readAsArrayBuffer(file);
      } catch (ex) {
        console.log(ex);
        //this.$Progress.fail();
      }
    },
    getPartnerDetails: function() {
      let partner = this.PartnerAPIData.slice();
      let dataTransferExcel = this.dataTransferExcel.slice();

      for (let i = 0; i < dataTransferExcel.length; i++) {
        if (dataTransferExcel[i].ReceiverReceiverID) {
          var result = partner.filter(function(obj) {
            if (obj.PartnerID) {
              return (
                obj.PartnerID.toString()
                  .trim()
                  .toLowerCase() ==
                dataTransferExcel[i].ReceiverReceiverID.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (result) {
            dataTransferExcel[i].ReceiverFullName = result.FullName;
            dataTransferExcel[i].ReceiverId = result.Id;
          }
        }
        if (dataTransferExcel[i].SenderSenderID) {
          var result = partner.filter(function(obj) {
            if (obj.PartnerID) {
              return (
                obj.PartnerID.toString()
                  .trim()
                  .toLowerCase() ==
                dataTransferExcel[i].SenderSenderID.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (result) {
            dataTransferExcel[i].SenderFullName = result.FullName;
            dataTransferExcel[i].SenderId = result.Id;
          }
        }
      }

      this.dataTransferExcel = dataTransferExcel;
    },

    getProgramDetails: function() {
      let Program = this.ProgramAPIData.slice();
      let dataTransferExcel = this.dataTransferExcel.slice();

      for (let i = 0; i < dataTransferExcel.length; i++) {
        if (dataTransferExcel[i].ProgramProgramID) {
          var result = Program.filter(function(obj) {
            if (obj.ProgramID) {
              return (
                obj.ProgramID.toString()
                  .trim()
                  .toLowerCase() ==
                dataTransferExcel[i].ProgramProgramID.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (result) {
            dataTransferExcel[i].ProgramTitle = result.Title;
            dataTransferExcel[i].ProgramAlias = result.Alias;
            dataTransferExcel[i].ProgramId = result.Id;
          }
        }
      }
      this.dataTransferExcel = dataTransferExcel;
    },

    DeleteDIfromGrid: function(e) {
      //e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message, "DELETE").then(result => {
        if (result.value) {
          var gview = window.$("#TransferUploadGrid").data("kendoGrid");
          var dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );
          //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
          //alert(JSON.stringify(dataItem));
          let objIndex = this.dataTransferExcel.findIndex(
            obj => obj.TransferKey == dataItem.TransferKey
          );
          this.dataTransferExcel.splice(objIndex, 1);
          var grid = $("#TransferUploadGrid").data("kendoGrid");
          grid.dataSource.data(this.dataTransferExcel);
        }
      });
    },

    SaveTransfer: function() {
      const self = this;
      let TransferCreateObject = {
        Transfer: {
          config: BaseTransfer,
          createData: this.dataTransferExcel.slice()
        }
      };
      //this._createAllItems(NewPartnerobject).then(addnewpartner => {
      //let loader = this.$loading.show();
       self._APICrudPopup("APICrudpopup");
      this.CreateAllItems(TransferCreateObject).then(
        response => {
          console.log(response);
          //self._AlertPopup("Transfer data saved successfully", "success");
         /** AUDIT DOCUMENT UPLOAD **/
          let FileUpload = [];
          let senderObj = {};
          //senderObj.Id = this.count++;
          let realfileName = this.inputfile.UploadFile[0].name;
         // senderObj.File = self._appendDatewithExcelName(fileName);
          senderObj.File = this.inputfile.UploadFile[0].upload.uuid
          senderObj.RealFileName = realfileName;
          senderObj.FileContent = this.inputfile.UploadFile[0];
          FileUpload.push(senderObj);
          this.UploadBulkAditFilesToDB(FileUpload)
            .then(response => {
              self._AlertPopup("Transfer data saved successfully", "success");
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
          /** AUDIT DOCUMENT UPLOAD END */
          this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
        }).catch(error=>{
            self._AlertPopup("Some Error Occurred!","info");
        }).finally(()=>{
            //loader.hide();
        })
    },
    ClearForm() {
      this.customerrors=[];
      this.dataTransferExcel = [];
      this.displayPage = false;
      this.isValid=false;
    },
    validateTransfer() {
      let self = this;
      //e.preventDefault();
      //let dataItem = $("#DirectInvestmentUploadGrid").data("kendoGrid").dataSource.data();
       let ProgramApiData=self.withFilter(BaseModelProgram.list);
        let PartnerApiData=self.withFilter(BaseModelPartner.list);
        let ClassApiData=self.withFilter(BaseModelUnitClass.list);
      var chkError = {
        reqProgramID: true,
        reqReceiverID: true,
        reqSenderID:true,
        reqUnitClass: true,
        reqUnitType: true,
        reqUnitPool: true,
        reqUnit: true,
        vldUnit:true,
        reqVestingType:true
      };
      self.isValid = true;
      self.customerrors=[];
      self.dataTransferExcel.forEach((ele, i) => {
        self.Columns = [];
        let programIndex = ProgramApiData.findIndex(f => f.ProgramID == ele.ProgramProgramID)
        if (ele.ProgramProgramID =="" || isNullOrUndefined(ele.ProgramProgramID) || programIndex < 0) 
        {
          self.Columns.push({ column: "ProgramProgramID", row: i });
          if (chkError.reqProgramID) {
            chkError.reqProgramID = false;
            self.customerrors.push(
              "Program ID is Empty or Invalid."
            );
          }
        }
        let sIndex = PartnerApiData.findIndex(f => f.PartnerID == ele.SenderSenderID)
        if(ele.SenderSenderID =="" || isNullOrUndefined(ele.SenderSenderID) || sIndex < 0)
        {
          self.Columns.push({ column: "SenderSenderID", row: i });
           if (chkError.reqSenderID) {
            chkError.reqSenderID = false;
            self.customerrors.push(
              "Transferor ID is Empty or Invalid."
            );
          }

        }

        let rIndex = PartnerApiData.findIndex(f => f.PartnerID == ele.ReceiverReceiverID)
        if (ele.ReceiverReceiverID =="" || isNullOrUndefined(ele.ReceiverReceiverID)||rIndex < 0) {
          self.Columns.push({ column: "ReceiverReceiverID", row: i });
           if (chkError.reqReceiverID) {
            chkError.reqReceiverID = false;
            self.customerrors.push(
              "Transferee ID is Empty or Invalid."
            );
          }
        }
        let unitClassIndex = ClassApiData.findIndex(f => f.UnitClass == ele.UnitClass)
        if (ele.UnitClass =="" || isNullOrUndefined(ele.UnitClass) || unitClassIndex < 0) {
          self.Columns.push({ column: "UnitClass", row: i });
           if (chkError.reqUnitClass) {
            chkError.reqUnitClass = false;
            self.customerrors.push(
              "Unit Class is Empty or Invalid."
            );
          }
        }
       let unitTypeIndex = self.dropdowns.UnitType.dataSource.findIndex(f => f.Option == ele.UnitType)
        if (ele.UnitType =="" || isNullOrUndefined(ele.UnitType) ||unitTypeIndex<0) {
          self.Columns.push({ column: "UnitType", row: i });
          if (chkError.reqUnitType) {
            chkError.reqUnitType = false;
            self.customerrors.push(
              "Unit Type is Empty or Invalid."
            );
          }
        }
        //VEsting Type
        let vestingTypeIndex = self.dropdowns.VestingType.dataSource.findIndex(f => f.Option == ele.VestingType)
        if (ele.VestingType =="" || isNullOrUndefined(ele.VestingType) ||vestingTypeIndex<0) {
          self.Columns.push({ column: "VestingType", row: i });
          if (chkError.reqVestingType) {
            chkError.reqVestingType = false;
            self.customerrors.push(
              "Vesting Type is Empty or Invalid."
            );
          }
        }
       let unitPoolIndex = self.dropdowns.UnitPool.dataSource.findIndex(f => f.Option == ele.UnitPool)
        if (ele.UnitPool =="" || isNullOrUndefined(ele.UnitPool) || unitPoolIndex < 0) {
          self.Columns.push({ column: "UnitPool", row: i });
           if (chkError.reqUnitPool) {
            chkError.reqUnitPool = false;
            self.customerrors.push(
              "Unit Pool is Empty or Invalid.."
            );
          }
        }
        if (isNullOrUndefined(ele.Unit)||ele.Unit<1) {
          self.Columns.push({ column: "Unit", row: i });
          if (chkError.vldUnit) {
            chkError.vldUnit = false;
            self.customerrors.push(
              "Unit is required and should be greater than 0 ."
            );
          }
        }
       
        self.Columns.push({ column: "Validation", row: i });

        if (self.Columns.length != 1 && self.isValid) {
          self.isValid = false;
        }
        self.ValidateImportData("TransferUploadGrid", self.Columns);
      });
    },
    getInputControls() {
        let self = this;
        let response = self.getLocalInputControls(BaseModelInputControl.list);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
        });
    }
  },

  mounted() 
  {
      this.getInputControls();
  }
};
</script>

